export const initialState = {
    account: true,
    loading: true,
    gender: [],
    documentType: [],
    invoiceType: [],
    accountInvoiceType:"",
    inputMask: '',
    year:[]
  }